module.exports = __webpack_public_path__ + "static/media/Petra.b91c0a79.jpg";